import { useTranslation } from "react-i18next";
import { getDisplayDatetime } from "../../helpers/display_help";
import { Fragment, useState } from "react";
import { Button } from "reactstrap";
import { RemarkField } from "./RemarkField";
import { getContractEndDate } from "../../helpers/data_conversion_helper";

function AdminDeviceRow(props) {
    const { t } = useTranslation();
    const [isCollapse, setCollapse] = useState(true);
    const data = props.data;
    return (
        <Fragment>
            <tr onClick={() => { setCollapse(!isCollapse); }}>
                <td className="fw-medium collapse-icon">
                    {isCollapse ? <i className="bx bxs-plus-square"></i> : <i className="bx bxs-minus-square"></i>}
                </td>
                <td className="fw-medium">{data["id"]}</td>
                <td>{props.companyName}</td>
                <td>{data["monitor_location_device_id"]}</td>
                <td>{data["installation_date"]}</td>
                <td>{data["uninstallation_date"]}</td>
                <td>{getContractEndDate(data)}</td>
                <td>{data["is_effective"] ? t('PageAdmin.DeviceStatus.Normal') : t('PageAdmin.DeviceStatus.Stopped')}</td>
                <td>{getDisplayDatetime(data["created_at"] * 1000)}</td>
                <td>{getDisplayDatetime(data["updated_at"] * 1000)}</td>
                <td style={{ padding: "0.51rem 0.6rem" }}>
                    <Button className="btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); props.onClickModify(); }}>{t('Common.Btn.Modify')}</Button>
                    <Button className="btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={(e) => { e.stopPropagation(); props.onSelectedUpdateDevice({deviceID: data["id"], companyID: data["admin_company_id"]}); }}>{t('PageAdmin.Btn.DeviceUpdate')}</Button>
                    <Button className="btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={(e) => { e.stopPropagation(); props.onSelectedContractDevice({deviceID: data["id"], companyID: data["admin_company_id"]}); }}>{t('PageAdmin.Btn.DeviceContract')}</Button>
                </td>
            </tr>
            {isCollapse ? null :
                <tr>
                    <td></td>
                    <td colSpan="10">
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.ToiletHeight')}</span>
                                <span type="text" className="form-control col-6">{data["toilet_height"]}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.IsInstalledThermalSensor')}</span>
                                <span type="text" className="form-control col-6">{data["is_installed_thermal_sensor"]?t('PageAdmin.InstalledStatus.Yes'):t('PageAdmin.InstalledStatus.No')}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.IsInstalledCeilingLight')}</span>
                                <span type="text" className="form-control col-6">{data["is_installed_ceiling_light"]?t('PageAdmin.InstalledStatus.Yes'):t('PageAdmin.InstalledStatus.No')}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.IsInstalledSignalTower')}</span>
                                <span type="text" className="form-control col-6">{data["is_installed_signal_tower"]?t('PageAdmin.InstalledStatus.Yes'):t('PageAdmin.InstalledStatus.No')}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.IsUsingOpuschat')}</span>
                                <span type="text" className="form-control col-6">{data["is_using_opuschat"]?t('PageAdmin.InstalledStatus.Yes'):t('PageAdmin.InstalledStatus.No')}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.OpuschatLink')}</span>
                                <span type="text" className="form-control col-6">{data["opuschat_url"]}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.AIVersion')}</span>
                                <span type="text" className="form-control col-6">{data["ai_version"]}</span>
                            </div>
                        </div>
                        <div className='d-flex flex-row align-items-center'>
                            <div className="input-group d-flex flex-row">
                                <span className="input-group-text col-xs-6 col-md-2" id="inputGroup-sizing-default">{t('PageAdmin.CompanyDeviceTable.Remark')}</span>
                                <div className="position-relative flex-grow-1">
                                    <RemarkField remark={data["remark"]} />
                                </div>
                            </div>
                        </div>

                    </td>
                </tr>}
        </Fragment>
    );
}

export default AdminDeviceRow;